module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container-fluid row mt-4\"> <div class=\"col-6 col-md-10 pl-0\"> <div> <ul class=\"list-group list-group-flush\"> <li class=\"list-group-item\"><strong>Estimated Delivery:</strong> ")
    ; __append(escapeFn( locals.estimatedDelivery ))
    ; __append("</li> <li class=\"list-group-item\"><strong>Warehouse:</strong> ")
    ; __append(escapeFn( locals.warehouse ))
    ; __append("</li> <li class=\"list-group-item\"><strong>Tracking Code:</strong> ")
    ; __append(escapeFn( locals.trackingCode ))
    ; __append("</li> </ul> </div> </div> <div class=\"col-4 col-md-2 text-right justify-content-end\"> <a href=\"")
    ; __append(escapeFn( locals.bolURL ))
    ; __append("\" target=\"_blank\" class=\"btn btn-primary\">Download</a> </div> </div> <div class=\"my-4\"> <h4 class=\"card-header pl-3 mt-3\">Products</h4> <div class=\"product-details\"> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/fulfillment_bols/details/template.ejs
// module id = 1670
// module chunks = 1